import type { GetSpeciesPropensityPropensitiesParams } from '@libs/common-types';
import { logger } from '@libs/core';

import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

export type SpeciesPropensityPropensitiesResponse = Record<string, unknown>;

export async function getSpeciesPropensityPropensities(
    params: GetSpeciesPropensityPropensitiesParams
): Promise<SpeciesPropensityPropensitiesResponse> {
    logger.info('[getSpeciesPropensityPropensities] params: %o', params);
    const url = CWEA_ENDPOINTS.speciesPropensity.getPropensities(params);
    return (await cweaClient.get<SpeciesPropensityPropensitiesResponse>(url, { useOldFetch: true })) ?? {};
}
